import React from 'react';
import { Helmet } from 'react-helmet-async';
import queryString from 'query-string';
import Redirect from '@/components/Redirect';
import { useUser } from '@lore/auth';
import PageHeader from '@/pages/people-people/PageHeader';

export default function Layout() {
  const currentUser = useUser();

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Explore educators</title>
      </Helmet>
      <PageHeader
        title="Explore educators"
        subtitle={(
          <>
            Connect with inspiring educators and explore their projects and events. Use
            filters to search by grade levels, subjects, and more.
          </>
        )}
      />
      <Redirect
        to={{
          pathname: '/educators',
          search: queryString.stringify({
            locationCondition: JSON.stringify({
              address: currentUser.data.zipCode,
              latitude: currentUser.data.latitude,
              longitude: currentUser.data.longitude,
              radius: 50
            })
          })
        }}
        replace={true}
      />
    </div>
  );
}
